import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Container, Form, Spinner } from "react-bootstrap";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import { updateStageAsync, getAStageAsync, setStageId, getAllStagesAsync } from "../../../../slices/settings/settingsSlice";
import { RootState } from "../../../../store/store";
import { toast } from "react-toastify";
interface EditStageValues {
    stage: string;
    company_id: string;
    id: string;
}
interface EditStageProps {
    closeModal: () => void;
    show: boolean;
    stageId: string;
    onEditSuccess: () => void;
}

const EditStage: React.FC<EditStageProps> = ({ closeModal, show, stageId, onEditSuccess }) => {
    const dispatch = useAppDispatch();
    const companyId = useAppSelector(
        (state: RootState) => state.auth.user?.company_id || "",
    );
    const stageData = useAppSelector((state: any) => state.settings.stageData);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);



    useEffect(() => {
        if (stageId) {
            dispatch(setStageId(stageId));
            console.log("Fetching stage with ID:", stageId);
            dispatch(getAStageAsync({ companyId, id: stageId })).then(() =>
                setLoading(false),
            );
        } else {
            console.log("stageId is not set");
        }
    }, [dispatch, companyId, stageId]);

    if (loading) {
        return null;
    }

    return (
        <Container fluid>
            <Modal
                centered
                size="lg"
                show={show}
                onHide={closeModal}
                style={{ maxHeight: "100vh", overflowY: "auto" }}>
                <div className="px-5">
                    <Formik
                        initialValues={{
                            stage: stageData?.stage || "",
                            company_id: companyId || "",
                            id: stageData?.id || "",
                        }}
                        validationSchema={
                            Yup.object().shape({
                                stage: Yup.string(),
                                company_id: Yup.string(),
                                id: Yup.string(),
                            })}
                        onSubmit={(values: EditStageValues, { setSubmitting }) => {
                            console.log("Submitting values:", values);
                            dispatch(
                                updateStageAsync({
                                    updateStageData: values,
                                    id: stageId || "",
                                }),
                            ).unwrap()
                                .then((response) => {
                                    toast.success("Stage updated successfully");
                                    dispatch(getAllStagesAsync({ companyId, page: currentPage }));
                                    onEditSuccess();
                                    closeModal();
                                })
                                .catch((error) => {
                                    const errorMessage = Object.values(error.message).flat().join(" ");
                                    toast.error(errorMessage);
                                })
                                .finally(() => {
                                    setSubmitting(false);
                                });
                        }}
                    >
                        {({
                            errors,
                            touched,
                            handleSubmit,
                            isSubmitting,
                            values,
                            handleChange,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Modal.Header closeButton className="text-start mt-3">
                                    <h4 className="confirm-header">Edit stage</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row>
                                        <Col className="mt-2">
                                            <label className="mt-2">
                                                <p>
                                                    Stage
                                                </p>
                                            </label>
                                            <Field
                                                type="text"
                                                name="stage"
                                                className={`fluent-input  ${touched.stage &&
                                                    errors.stage
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}

                                            />
                                        </Col>
                                    </Row>
                                    <Modal.Footer className="mt-5">
                                        <Row>
                                            <Col md={6}>
                                                <div className=" mt-1">
                                                    <Button onClick={closeModal} className="cancel-btn">
                                                        <span className="text-center">Cancel </span>{" "}
                                                    </Button>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className=" mt-1">
                                                    <Button
                                                        type="submit"
                                                        className=" border-0 create-btn bg-color-1"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? (
                                                            <Spinner animation="border" size="sm" />
                                                        ) : (
                                                            <span className="text-center">Edit stage</span>
                                                        )}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Modal.Footer>
                                </Modal.Body>
                            </Form>
                        )}
                    </Formik>
                </div>

            </Modal>
        </Container>
    );
};

export default EditStage;